// extracted by mini-css-extract-plugin
export var anchor = "form-module--anchor--yBX2Y";
export var form = "form-module--form--ihM87";
export var formContainer = "form-module--formContainer--b8sHC";
export var head = "form-module--head--ZLJzl";
export var img = "form-module--img--6Tvaj";
export var info = "form-module--info--Fvh6a";
export var refin = "form-module--refin--nZZa+";
export var section = "form-module--section--KoVs-";
export var subtitle = "form-module--subtitle--Ye--7";
export var timer = "form-module--timer--XqKmQ";